export const PledgeAutoTexts = {
  submitButtonLabel: 'Отправить заявку',
  popupHeader: 'Информация о залоге',
};
